export const jobchartFiles = (
  state = {
    products: [{ files: [] }],
    fileArray: { 0: [] },
    productIndexes: {},
  },
  action
) => {
  if (action.type === 'SET_JOBCHART_FILES') {
    const { productIndex, file, isRemove = false } = action.payload;

    if (!isRemove) {
      if (!state.products[productIndex]) {
        state.products[productIndex] = { files: [file] };
        state.fileArray[productIndex] = [file.name];
      } else {
        state.products[productIndex].files.push(file);
        state.fileArray[productIndex].push(file.name);
      }
      state.productIndexes[file.name] = productIndex;
    } else if (state.products[productIndex]) {
      const index = state.products[productIndex].files.indexOf(file);

      if (index > -1) {
        state.products[productIndex].files.splice(index, 1);
        state.fileArray[productIndex].splice(index, 1);
      }
      delete state.productIndexes[file.name];
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'DELETE_PRODUCT_JOBCHART') {
    const { productIndex } = action.payload;

    state.products.splice(productIndex, 1);

    delete state.fileArray[productIndex];

    for (const key of Object.keys(state.fileArray).sort()) {
      if (key === productIndex) {
        delete state.fileArray[key];
      }
      if (key > productIndex) {
        state.fileArray[key - 1] = state.fileArray[key];

        delete state.fileArray[key];
      }
    }

    for (const [key, value] of Object.entries(state.productIndexes)) {
      if (value === productIndex) {
        delete state.productIndexes[key];
      }
      if (value > productIndex) {
        state.productIndexes[key] = value - 1;
      }
    }

    const newState = { ...state };

    return newState;
  }

  if (action.type === 'CLEAR_JOBCHART_FILES') {
    return {
      products: [{ files: [] }],
      fileArray: { 0: [] },
      productIndexes: {},
    };
  }

  return state;
};

// const _state = {
//   products: [{ files: [] }],
//   fileArray: {
//     0: ['file.name'],
//   },
// };

export const jobcharts = (state = [], action) => {
  if (action.type === 'FETCH_JOBCHARTS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_JOBCHARTS') {
    return [];
  }
  return state;
};

export const jobchart = (state = {}, action) => {
  if (action.type === 'FETCH_JOBCHART') {
    return action.payload;
  }
  if (action.type === 'CLEAR_JOBCHART') {
    return {};
  }
  return state;
};

export const jobchartPreview = (state = {}, action) => {
  if (action.type === 'FETCH_JOBCHART_PREVIEW') {
    return action.payload;
  }
  if (action.type === 'CLEAR_JOBCHART_PREVIEW') {
    return {};
  }
  return state;
};

export const activeJobchartIds = (state = [], action) => {
  if (action.type === 'FETCH_ACTIVE_JOBCHART_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ACTIVE_JOBCHART_IDS') {
    return [];
  }
  return state;
};

export const savedJobcharts = (state = [], action) => {
  if (action.type === 'FETCH_SAVED_JOBCHARTS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_SAVED_JOBCHARTS') {
    return [];
  }
  return state;
};

export const jobchartAcknowledgements = (state = [], action) => {
  if (action.type === 'FETCH_JOBCHART_ACKNOWLEDGEMENTS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_JOBCHART_ACKNOWLEDGEMENTS') {
    return [];
  }

  return state;
};
